/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ISeparatorProps, Separator } from '@fluentui/react/lib/Separator';
import * as React from 'react';
import { getStylist } from 'src/core/themes/luisStylist';

const { getClassName } = getStylist('Card');

const darkSeparatorClass = getClassName('darkSeparatorClass', theme => ({
    padding: 0,
    fontSize: 0,
    $nest: {
        '&::before': { backgroundColor: theme.separatorLineColor },
        '&::after': { backgroundColor: theme.separatorLineColor }
    }
}));

/**
 * Represents a horizontal line separator.
 */
export const LuisSeparator = (props: ISeparatorProps) => <Separator className={darkSeparatorClass} {...props} />;
